import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"r_mobiledata"}/>
}
